<template>
  <div class="is_headapp">
    <h1>Промежуточная приёмка</h1>
    <pre v-if="0">
      boxes: {{boxes}}
      num: {{num}}
    </pre>
    <template v-if="success">
      <p style="font-weight: bold; color: green;">Статус заказа успешно изменён</p>
    </template>
    <template v-else>
      <template v-if="!boxes.length">
          <p>
            <b>Шаг1</b><br>
            Введите или отсканируйте код пломбы:
          </p>
          <v-text-field 
            v-model="value"
            autofocus
            @keyup.enter="scan_plomb"
            label="Введите код"
          />
      </template>
      <template v-if="boxes.length">
          <p>
            <a href="" @click.prevent="boxes=[]"><v-icon x-small>fa fa-arrow-left</v-icon> назад</a><br>
            <b>Шаг 2</b>
            <br>
            Вы отсканировали код пломбы <b>{{plomb_code}}</b> Теперь отсканируйте места:
          </p>
          <v-text-field 
            v-model="value"
            autofocus
            @keyup.enter="scan_box"
            label="Введите код"
          />
        
          <template v-if="boxes.length">
            <table class="tbl1">
              <tr class="h">
                <td><b>Номер места</b></td>
                <td><b>Код пломбы</b></td>
                <td><b>Описание</b></td>
                <td>&nbsp;</td>
              </tr>
              <tr v-for="(l,idx) in boxes">
                  <td>
                    №{{l.num_place}}
                    <div v-if="!l.id" style="color: red;">не было зарегистрировано ранее</div>
                  </td>
                  <td>{{l.plomb_code}}</td>
                  <td><v-textarea v-model="l.body" label="Описание" /></td>
                <td class="actions"><v-icon :style="{color: l.accept?'green':''}">fa fa-check-circle</v-icon></td>
              </tr>
            </table>
            <div style="margin-top: 20px;">
              <v-btn @click="accept_all()">Принять</v-btn>
            </div>
            <p v-if="accept_all_error" style="margin-top: 10px; font-weight: bold; color: red">{{accept_all_error}}</p> <!-- ошибка при подтверждении -->
          </template>
          <template v-else>
            <p class="error">Нет ни одной коробки в заказе</p>
          </template>
      </template>

    </template>
<!--       <template v-else>
        <p>По коду: {{value}} ничего не найдено</p>
      </template> -->
      

    
<!--     <v-btn @click="sound_success">success</v-btn>
    <v-btn @click="sound_fail">fail</v-btn> -->
  </div>

</template>

<script>
import { fixBarcode} from '../js/fixBarcode.js';
export default {
  //name:'firstInitIM',
  data(){
    return {
      
      num:0, // для отложенного ajax-а
      value:'', // код для поиска
      plomb_code:'',
      order:null, // отсканированная заявка
      list:[ // сканированные box-ы
        /*{type:'order',id:1},
        {type:'box',num_place:'76176276', id:1},*/
      ],
      sounds: {
          success: null,
          fail: null,
      },
      success: false, // сообщение об успешном добавлении
      accept_all_error: '', // сообщение об ошибке при добавлении "пропикиваний"
      boxes:[]
    }
  },
  created(){
    let t=this
    t.sounds.success = new Audio('/delivery/success.ogg');
    t.sounds.fail = new Audio('/delivery/fail.ogg');
    // t.$nextTick(() => {
    //   t.$refs.barcodeInput.focus();
    // });
  },
  methods:{
    sound_success(){
      this.sounds.success.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.success.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    sound_fail(){
      this.sounds.fail.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.fail.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    delete_from_list(idx){
      // удаляет из списка позицию
      this.list.splice(idx,1)
    },

    scan_plomb(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      if(!t.value){
        return 
      }
      t.num++
      t.plomb_code=t.value
      setTimeout(
        ()=>{
          t.num--
          if(!t.num){ // поиск 
            t.$http.post(BackendBase+'/delivery/middle-init/scan-plomb',{
              plomb_code: t.plomb_code
            }).then(
              r=>{
                let d=r.data
                console.log('d:',d)
                if(d.success){
                  t.boxes=[] ; t.value=''
                  if(d.boxes.length){
                    t.sound_success()
                    for(let b of d.boxes){
                      b.accept=false
                      t.boxes.push(b)
                    }
                  }
                  else{
                    t.sound_fail()
                  }
                }
              }
            )
          }
        },
        300
      )
    },
    accept_box(id){
      for(let b of this.boxes){
        console.log('b:',b, '; id: ',id)
        if(b.id==id){
          b.accept=true
        }
      }
    },
    scan_box(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      if(!t.value){
        return 
      }
      t.num++

      setTimeout(
        ()=>{
          t.num--
          if(!t.num){ // поиск 
            t.$http.post(BackendBase+'/delivery/middle-init/scan-box',{
              value: t.value,
              plomb_code: t.plomb_code
            }).then(
              r=>{
                let d=r.data
                
                if(d.success){
                  
                  if(d.box){ // место найдено
                    t.accept_box(d.box.id)
                    //t.list.push(d.box)
                    t.sound_success()
                  }
                }
                else{
                     t.sound_fail()
                }
                t.value=''
                
              }
            )
          }
        },
        300
      )
    },

    accept_all(){ // отравляется в приёмку накликанный список
      let t=this
      // показывает сообщение об ошибке
      const show_error=(error)=>{
        t.accept_all_error=error
        setTimeout( ()=>{ t.accept_all_error=false },900 )
      }

      let accept_any=false
      for(let b of t.boxes){
        if(b.accept){
          accept_any=true
        }
      }
      
      if(!accept_any){
        show_error('Нужно, чтобы была принята хотя бы одна коробка с пломбой')
        return 
      }

      t.$http.post(
        BackendBase+'/delivery/middle-init/accept-boxes',
        {
          list:t.boxes,
        }
      ).then(
        r=>{
          let d=r.data
          if(d.success){
            t.success=true
            setTimeout(
              ()=>{
                t.list=[] ; t.boxes=[]
                t.order=null
                t.success=false
              },900
            )
          }
          else if(d.error){
            show_error(d.error)
          }
        }
      )
      
    },
  },
  watch:{
    value(){
      if(this.value){
        this.value=fixBarcode(this.value)
      }
    }
  }
}
</script>

<style scoped>
  .is_headapp {margin: 20px; max-width: 1400px;}
  .is_headapp h1 {margin-bottom: 20px;} 
  .order, .box {border: 1px solid gray; padding: 20px; margin-bottom: 20px; border-radius: 15px;  font-weight: bold;}
  .order {background-color: #3f674a;}
  .box {background-color: #71be86;}
  td.actions {width: 0px;}
</style>